import { render } from "./About.vue?vue&type=template&id=3e4ab606&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=3e4ab606&lang=scss&scoped=true"
import "./About.vue?vue&type=style&index=1&id=3e4ab606&lang=scss"
script.render = render
script.__scopeId = "data-v-3e4ab606"

export default script